import { render, staticRenderFns } from "./ZoneConLomAwardEdit.vue?vue&type=template&id=20f0e59d"
import script from "./ZoneConLomAwardEdit.vue?vue&type=script&lang=js"
export * from "./ZoneConLomAwardEdit.vue?vue&type=script&lang=js"
import style0 from "./ZoneConLomAwardEdit.vue?vue&type=style&index=0&id=20f0e59d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports